import "./styles.css";
import Laptop from "../../assets/laptop.png";
import Scrapcycle from "../../assets/scrapcyclemobile.gif";
import Codepen from "../../assets/codepen.gif";
import Foodgarage from "../../assets/foodgarage.gif";
import IDScan from "../../assets/QRScan.gif";
import RDPLines from "../../assets/RDP_Lines.gif";
import AlbertosPizza from "../../assets/albertos_pizza.gif";
import ScrapCycleWeb from "../../assets/scrapcycle_web.gif";
import ScrollAnimation from "react-animate-on-scroll";

export function Projects() {

  return (
    <div className="projects" id="projects">
      <ScrollAnimation animateIn="fadeInUp">
        <h1 className="projectsTitle">Here are some of my projects</h1>
      </ScrollAnimation>
      <div className="project">
        <ScrollAnimation animateIn="fadeInRight">
          <div className="phone">
            <img className="cellphone" src={Scrapcycle} alt="Phone" />
          </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">ScrapCycle App</h1>
          <p className="projectDesc">
            ScrapCycle is an online junkshop mobile app where people can easily
            trade their recyclable trash (plastic, glass, metals, electronics,
            etc.) for money. Scrapcycle aims to simplify the process of selling
            recyclables to a junkshop, increase the quantity of recyclables
            turned into new products by recycling factories, and to promote a
            more sustainable and a cleaner future—one scrap at a time.
          </p>

          <footer>
            <ul className="tech-list">
              <li>Flutter</li>
              <li>Dart</li>
              <li>Firebase</li>
              <li>Android Studio</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://play.google.com/store/apps/details?id=scrapcycle.com&hl=en-PH"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton">Learn More</button>
            </a>

            <a
              href="https://github.com/BustamanteFlocer/Scrapcycle_Android_App"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>
      <div className="project">
        <ScrollAnimation animateIn="fadeInLeft">
          <div className="laptop">
            <div className="scroll">
              <img className="laptopimg" src={Laptop} alt="Laptop" />
              <div className="laptopScreen">
                <img className="laptopApp" src={AlbertosPizza} alt="" />
              </div>
            </div>
          </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">Alberto's Pizza</h1>
          <p className="projectDesc">
            Albertos Pizza offers a seamless online pizza ordering experience
            with a user-friendly interface. Customers can order pizzas easily,
            choosing between PayPal and Cash on Delivery. The Admin Dashboard
            enables efficient menu management and real-time order tracking.
          </p>
          <footer>
            <ul className="tech-list">
              <li>Nextjs</li>
              <li>MongoDB</li>
              <li>Javascript</li>
              <li>Redux</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://albertos-pizza.vercel.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton">Learn More</button>
            </a>
            <a
              href="https://github.com/BustamanteFlocer/Albertos_Pizza"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>

      <div className="project">
        <ScrollAnimation animateIn="fadeInRight">
          <div className="laptop">
            <div className="scroll">
              <img className="laptopimg" src={Laptop} alt="Laptop" />
              <div className="laptopScreen">
                <img className="laptopApp" src={RDPLines} alt="" />
              </div>
            </div>
          </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">RDPLines</h1>
          <p className="projectDesc">
            RDPLine is a time series line simplification and visualization
            generator with an optimized Ramer-Douglas-Peucker algorithm that
            implements parallel computing and dynamic epsilon adjustments based
            on dataset characteristics.
          </p>
          <footer>
            <ul className="tech-list">
              <li>Reactjs</li>
              <li>Flask</li>
              <li>Javascript</li>
              <li>Python</li>
            </ul>
          </footer>

          <div className="buttons">
            <a
              href="https://github.com/BustamanteFlocer/RDPLines"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>

      <div className="project">
        <ScrollAnimation animateIn="fadeInLeft">
          <div className="laptop">
            <div className="scroll">
              <img className="laptopimg" src={Laptop} alt="Laptop" />
              <div className="laptopScreen">
                <img className="laptopApp" src={IDScan} alt="" />
              </div>
            </div>
          </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">IDScan</h1>
          <p className="projectDesc">
            IDScan makes attendance tracking easier by utilizing QR code
            scanning of a student ID. With unique QR codes assigned to each
            student, the process is streamlined, and the admin dashboard
            provides real-time insights, report generation, and sanctions
            management.
          </p>
          <footer>
            <ul className="tech-list">
              <li>PHP</li>
              <li>Laravel</li>
              <li>MySql</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://github.com/BustamanteFlocer/Attendance-Management-System"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>

      <div className="project">
      <ScrollAnimation animateIn="fadeInRight">
        <div className="laptop">
          <div className="scroll">
            <img className="laptopimg" src={Laptop} alt="Laptop" />
            <div className="laptopScreen">
              <img className="laptopApp" src={Codepen} alt="" />
            </div>
          </div>
        </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">Codepen Clone</h1>
          <p className="projectDesc">
            This is a website that clones the functionality of CodePen but is
            built entirely with ReactJS and integrates the CodeMirror library.
            This project aims to provide a user-friendly environment for
            developers to experiment with HTML, CSS, and JavaScript code in
            real-time.
          </p>
          <footer>
            <ul className="tech-list">
              <li>ReactJS</li>
              <li>Javascript</li>
              <li>CodeMirror</li>
              <li>Vercel</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://code-pen-clone-seven.vercel.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton">Learn More</button>
            </a>

            <a
              href="https://github.com/BustamanteFlocer/CodePen-Clone"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>

      <div className="project">
      <ScrollAnimation animateIn="fadeInLeft">
        <div className="laptop">
          <div className="scroll">
            <img className="laptopimg" src={Laptop} alt="Laptop" />
            <div className="laptopScreen">
              <img className="laptopApp" src={Foodgarage} alt="" />
            </div>
          </div>
        </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">Food Garage</h1>
          <p className="projectDesc">
            Food Garage, is a web project designed to showcase the culinary
            excellence of Food Garage Restaurant. Powered by a user-friendly
            Content Management System, the website ensures that you receive
            real-time information about the menu and happenings, reflecting the
            commitment to transparency and engagement.
          </p>
          <footer>
            <ul className="tech-list">
              <li>CMS</li>
              <li>Wordpress</li>
              <li>Elementor</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://github.com/BustamanteFlocer/Food-Garage-Website-Prototype"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>

      <div className="project">
      <ScrollAnimation animateIn="fadeInRight">
        <div className="laptop">
          <div className="scroll">
            <img className="laptopimg" src={Laptop} alt="Laptop" />
            <div className="laptopScreen">
              <img className="laptopApp" src={ScrapCycleWeb} alt="" />
            </div>
          </div>
        </div>
        </ScrollAnimation>
        <div className="projectDetail">
          <h1 className="projectTitle">ScrapCycle Website</h1>
          <p className="projectDesc">
            The ScrapCycle website is a platform dedicated to advancing
            sustainability through its mobile app. The web platform is designed
            to introduce users to the ScrapCycle app and provide in-depth
            insights into its functionalities, empowering them to make informed
            choices for a greener tomorrow.
          </p>
          <footer>
            <ul className="tech-list">
              <li>Laravel</li>
              <li>PHP</li>
              <li>Vite</li>
              <li>MySql</li>
            </ul>
          </footer>
          <div className="buttons">
            <a
              href="https://github.com/BustamanteFlocer/ScrapCycle_Website"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectButton1">View Code</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
